import type {
  DetailsSuccess,
} from '@autobid/strapi-integration/typescript/auction/detailsCar'
import type { ItemPublishEvent } from '@autobid/ui/types/websocket/ItemPublishEvent'
import type { Ref } from 'vue'
import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import {
  carDetailsQueryKey,
} from '@autobid/ui/composables/car/data/useDetailsCar'
import { DETAILS_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useDetailsSocket'
import { randomDebounce } from '@autobid/ui/utils/randomDebounce'
import { useQueryClient } from '@tanstack/vue-query'

export function useDetailsItemPublish() {
  const { startListen } = useWebSocketStore()
  const queryClient = useQueryClient()

  const itemPublishDebounce = useState(
    'details-item-publish-debounce',
    () => ({}),
  ) as Ref<Record<number, NodeJS.Timeout>>

  const itemPublish = () => {
    const invalidateDetails = (event: ItemPublishEvent) => {
      const { auctionId, itemId } = event.context
      const detailsQueryBaseKey = carDetailsQueryKey.all()[0]

      queryClient.invalidateQueries({
        predicate: (query) => {
          if (!Array.isArray(query.queryKey))
            return false

          if (query.queryKey[0] !== detailsQueryBaseKey)
            return false

          const queryData = query.state
            .data as DetailsSuccess['data']['singleItem']

          if (!queryData)
            return false

          if (queryData.item.itemData.auctionId === auctionId)
            return true

          return queryData.item.itemData.id === itemId
        },
      })
    }

    startListen({
      eventName: 'premium.ITEM_PUBLISH',
      callbackName: DETAILS_SOCKET_CALLBACK,
      callback: (event) => {
        clearTimeout(itemPublishDebounce.value[event.context.auctionId])

        itemPublishDebounce.value[event.context.auctionId] = randomDebounce(
          1000,
          3000,
          () => {
            invalidateDetails(event)
          },
        )
      },
    })
  }

  return { itemPublish }
}
